export const MATCH_BOTTERO_READ_ONLY_DEFAULT_FILTERS = {
  search: "",
  bsArticolo: "",
  vsArticolo: "",
  bsCodModello: "",
  vsCodModello: "",
  bsCodColore: "",
  vsCodColore: "",
  vsCodProduttore: "",
  bsBrand: "",
  bsBrandConvertito: "",
  vsBrand: "",
  bsVariante: "",
  vsVariante: "",
  bsTaglia: "",
  vsTaglia: "",
  bsNome: "",
  tagDaAggiungere: "",
  vsNome: "",
  motiviArtVar: "",
  motiviTaglia: "",
  motiviCreazione: "",
  motiviIgnorato: "",
  ok: "",
  hasGiacenza: "",
};

export const MATCH_BOTTERO_READ_ONLY_ADVANCED_FILTER_FIELDS = [
  ["search", "Ricerca libera"],
  ["bsArticolo", "BS Articolo"],
  ["vsArticolo", "VS Articolo"],
  ["bsCodModello", "BS Cod modello"],
  ["vsCodModello", "VS Cod modello"],
  ["bsCodColore", "BS Cod colore"],
  ["vsCodColore", "VS Cod colore"],
  ["vsCodProduttore", "VS Cod produttore"],
  ["bsBrand", "BS Brand"],
  ["bsBrandConvertito", "BS Brand (convertito)"],
  ["vsBrand", "VS Brand"],
  ["bsVariante", "BS Variante"],
  ["vsVariante", "VS Variante"],
  ["bsTaglia", "BS Taglia"],
  ["vsTaglia", "VS Taglia"],
  ["bsNome", "BS Nome"],
  ["tagDaAggiungere", "Tag assegnato"],
  ["vsNome", "VS Nome"],
  ["motiviArtVar", "Motivo art-var (codice)"],
  ["motiviTaglia", "Motivo taglia (codice)"],
  ["motiviCreazione", "Motivo creazione (codice)"],
  ["motiviIgnorato", "Motivo ignorato (codice)"],
];

export const MATCH_BOTTERO_MOTIVI_LABELS = {
  auto_art_var_ean: "Auto EAN (art-var)",
  auto_art_var_unique_producer: "Auto cod-prod univoco",
  auto_art_var_unique_prod_size: "Auto cod-prod+taglia univoci",
  auto_taglia_ean: "Auto EAN (taglia)",
  auto_taglia_matcha: "Auto taglia uguale",
  auto_taglia_convertita_exact: "Auto taglia convertita exact",
  auto_taglia_convertita_loose: "Auto taglia convertita loose",
  auto_taglia_unique_prod_size: "Auto taglia da cod-prod+taglia",
  auto_create_brand_not_in_vs: "Auto brand non presente in VS",
  auto_create_special_group7: "Auto gruppo7 speciale",
  auto_create_special_group1_58: "Auto campionario (58)",
  auto_create_special_group1_50: "Auto outlet (50)",
  auto_create_special_group1_49: "Auto contratto atleti Bottero (49)",
  auto_create_special_group1_44: "Auto contratto atleti (44)",
  auto_create_special_group1_38: "Auto riparazioni (38)",
  auto_create_special_group1_26: "Auto articoli regalo (26)",
  auto_create_special_group1_99: "Auto noleggio (99)",
  auto_ignore_not_in_movimenti: "Auto fuori movimenti",
  auto_ignore_giacenza_zero: "Auto giacenza BS zero",
  manual_set_match: "Manuale set match",
  manual_set_create: "Manuale set creazione",
  manual_set_taglia_da_aggiungere: "Manuale taglia da aggiungere",
  manual_set_articolo_da_rifare: "Manuale articolo da rifare",
  manual_set_ignore: "Manuale taglia da ignorare",
};

export const MATCH_BOTTERO_MOTIVI_FILTER_OPTIONS = {
  motiviArtVar: [
    "auto_art_var_ean",
    "auto_art_var_unique_producer",
    "auto_art_var_unique_prod_size",
    "manual_set_match",
  ],
  motiviTaglia: [
    "auto_taglia_ean",
    "auto_taglia_matcha",
    "auto_taglia_convertita_exact",
    "auto_taglia_convertita_loose",
    "auto_taglia_unique_prod_size",
    "manual_set_match",
    "manual_set_taglia_da_aggiungere",
    "manual_set_articolo_da_rifare",
  ],
  motiviCreazione: [
    "auto_create_brand_not_in_vs",
    "auto_create_special_group7",
    "auto_create_special_group1_58",
    "auto_create_special_group1_50",
    "auto_create_special_group1_49",
    "auto_create_special_group1_44",
    "auto_create_special_group1_38",
    "auto_create_special_group1_26",
    "auto_create_special_group1_99",
    "manual_set_create",
  ],
  motiviIgnorato: [
    "auto_ignore_not_in_movimenti",
    "auto_ignore_giacenza_zero",
    "manual_set_ignore",
  ],
};
